import { UserStatus } from '~/models/user';
import { transformTypeOptions } from '~/utils/common';
import { CustomerSupportTableLabels } from '~/models/driver';
import { ICustomerSupport } from './types';

export const DRIVER_DRAWER_TAB_VALUE = {
  PROFILE: 'profile',
  SHIFT: 'shift Schedule',
  VEHICLES: 'vehicle',
  DOCS: 'documents',
  TIMELINES: 'timeline',
};

export const DRIVER_DRAWER_TABS = transformTypeOptions(DRIVER_DRAWER_TAB_VALUE);

export const DRIVER_DOCS = [
  { id: 'license_photo_front', label: 'Driver License Photo - Front' },
  { id: 'license_photo_back', label: 'Driver License Photo- Back' },
  { id: 'driver_and_license', label: 'Photo of Driver with License' },
  { id: 'driver_abstract', label: 'Driver’s Abstract', isMultiple: true },
];

export const DRIVER_STATUS = {
  pending: 'Pending invite',
  online: 'Online',
  offline: 'Offline',
  idle: 'Idle',
};

export const StatusOptions = [
  {
    label: DRIVER_STATUS[UserStatus.Online],
    value: UserStatus.Online,
  },
  {
    label: DRIVER_STATUS[UserStatus.Offline],
    value: UserStatus.Offline,
  },
  {
    label: DRIVER_STATUS[UserStatus.Idle],
    value: UserStatus.Idle,
  },
  {
    label: DRIVER_STATUS[UserStatus.Pending],
    value: UserStatus.Pending,
  },
];

export const CustomerSupportOptions = [
  {
    value: ICustomerSupport.ContactDriverPhone,
    label: CustomerSupportTableLabels[ICustomerSupport.ContactDriverPhone],
  },
  {
    value: ICustomerSupport.ContactAlternativePhone,
    label: CustomerSupportTableLabels[ICustomerSupport.ContactAlternativePhone],
  },
  {
    value: ICustomerSupport.NoContact,
    label: CustomerSupportTableLabels[ICustomerSupport.NoContact],
  },
];

export const ShiftScheduleOptions = [
  {
    value: 'sunday',
    label: 'Sunday',
  },
  {
    value: 'monday',
    label: 'Monday',
  },
  {
    value: 'tuesday',
    label: 'Tuesday',
  },
  {
    value: 'wednesday',
    label: 'Wednesday',
  },
  {
    value: 'thursday',
    label: 'Thursday',
  },
  {
    value: 'friday',
    label: 'Friday',
  },
  {
    value: 'saturday',
    label: 'Saturday',
  },
];

export const DEFAULT_SHIFT = {
  all_hour: true,
  available: true,
  shifts: [
    {
      start_time: '09:00',
      end_time: '21:00',
      pause_assign: 0,
    },
  ],
};

export const DEFAULT_SPECIAL_SHIFT = {
  all_hour: true,
  available: true,
  shifts: [
    {
      start_time: '09:00',
      end_time: '21:00',
      pause_assign: 0,
    },
  ],
  name: '',
  start_date: '',
  end_date: '',
};

export const DEFAULT_DELIVERY = {
  enable_delivery: false,
  special_hours: [],
  delivery_hours: {
    sunday: DEFAULT_SHIFT,
    monday: DEFAULT_SHIFT,
    tuesday: DEFAULT_SHIFT,
    wednesday: DEFAULT_SHIFT,
    thursday: DEFAULT_SHIFT,
    friday: DEFAULT_SHIFT,
    saturday: DEFAULT_SHIFT,
  },
};

export const GAP_TIME_OPTIONS = [
  {
    value: '10',
    label: '10 minutes prior',
  },
  {
    value: '20',
    label: '20 minutes prior',
  },
  {
    value: '30',
    label: '30 minutes prior',
  },
  {
    value: '40',
    label: '40 minutes prior',
  },
  {
    value: '50',
    label: '50 minutes prior',
  },
  {
    value: '60',
    label: '1 hour prior',
  },
];
